import { BaseApiClient } from '@/common/helpers/BaseApiClient'

export default class VesselClient extends BaseApiClient {
  static async requiredDocuments () {
    return this.get('vessel/required-documents', {
      headers: this.getAuthHeaders()
    }).then(response => response.data.data)
  }
}
